import React from "react";
import { MessageCircle } from "lucide-react";

// Vaishali Fuels dispatch WhatsApp number
export const WHATSAPP_NUMBER = "919512477777";

export function buildWhatsAppLink(message) {
    const encoded = encodeURIComponent(message);
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
}

export default function FloatingWhatsApp() {
    const message = "Hi Vaishali Fuels — I would like to enquire about doorstep diesel delivery.";
    return (
        <a
            href={buildWhatsAppLink(message)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="floating-whatsapp-btn"
            className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white h-14 pl-4 pr-5 rounded-full shadow-lg transition-transform hover:-translate-y-0.5 group"
        >
            <MessageCircle className="w-6 h-6" />
            <span className="hidden sm:inline font-heading font-bold text-sm uppercase tracking-wider">
                WhatsApp
            </span>
        </a>
    );
}
